// extracted by mini-css-extract-plugin
export default {"big":"FileCard-size_big__QWT6e","medium":"FileCard-size_medium__oWTBS","small":"FileCard-size_small__aOqIy"};